// React
import { PropsWithChildren, createContext } from "react"


// Utils
import { useLinkAccountByCode } from "../utils"

interface FetchType {
  coa_code: string
  coa_name: string
  group_coa_code: string
  coa_id: number
}

export const LinkAccountContext = createContext<{
  data: FetchType | null
  isLoading: boolean,
  refetch?: (location_id: string, transaction_date: string) => void
}>({
  data: null,
  isLoading: false
})

export function LinkAccountProvider(params: PropsWithChildren<{}>): JSX.Element {
  // Hooks
  const { data, isLoading } = useLinkAccountByCode('LA10')

  return (
    <LinkAccountContext.Provider value={{ data, isLoading }}>
      {params.children}
    </LinkAccountContext.Provider>
  )
}